'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var constants = require('./lib/constants');
var path = require('./lib/path');
var plan = require('./lib/plan');
var config = require('./config');

function Goal(_ref) {
  var inflation = _ref.inflation,
      restParams = _objectWithoutProperties(_ref, ['inflation']);

  var state = _extends({}, restParams, { inflation: inflation / 100 });
  var goalConstants = constants(state);

  return _extends({
    regularInvestment: Math.round(goalConstants.regularInvestment),
    maxStartingAllocation: Math.round(goalConstants.maxStartingAllocation),
    inflation: state.inflation
  }, path(state, goalConstants));
}

function Plan(_ref2) {
  var inflation = _ref2.inflation,
      restParams = _objectWithoutProperties(_ref2, ['inflation']);

  var state = _extends({}, restParams, { inflation: inflation / 100 });
  return plan(state);
}

module.exports = { Goal: Goal, Plan: Plan, config: config };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/index.js
// module id = 41
// module chunks = 0